module.exports = {
	"AlsoToday": "Aujourd'hui également",
	"Archive": "Archives",
	"ClickHereForMoreInfo": "Cliquez ici pour plus d'informations",
	"ClientWebServiceNotResponding": "Le service d'authentification est actuellement indisponible.",
	"Confirm": "Confirmer",
	"Digital": "Numérique",
	"DigitalVersion": "Version numérique",
	"Edition": "Edition",
	"GTM_Authenticated": "Authentifié",
	"GTM_Anonymous": "Anonyme",
	"Help": "Aide",
	"HorsSeries": "Hors séries",
	"LoadingNewspaperPleaseWait": "Chargement du journal, merci de patienter",
	"LogIn": "Se connecter",
	"LogInWith": "Se connecter avec:",
	"MaximumDeviceNumberReached": "Vous avez atteint la limite du nombre d'appareils distincts autorisés à consulter cette publication",
	"ModernBrowserRequired": "Pour lire le journal digital, vous devez utiliser IE9 au minimum. Nous vous recommandons de mettre à jour votre navigateur",
	"More": "Plus",
	"Newspaper": "Journal",
	"NewspaperCurrentlyUnavailable": "Le journal ne peut être ouvert pour le moment. Merci de ré-essayer plus tard",
	"NoDigitalAccess": "Vous n’avez pas d’accès digital",
	"OK": "OK",
	"Paper": "Papier",
	"PaperVersion": "Version papier",
	"Password": "Mot de passe",
	"PleaseFillInAllFields": "Merci de remplir tous les champs",
	"Promospot": "Promospot",
	"ReadingPreference": "Préférences de lecture",
	"Read": "Lire",
	"ReadTheNewspaper": "Lire",
	"Register": "Cliquez ici pour vous inscrire",
	"SelectEdition": "Choix de l'édition",
	"SignIn": "Se connecter",
	"SignOut": "Se déconnecter",
	"SSOValidationFailed": "L'authentification automatique a échoué",
	"Subscription": "Abonnement",
	"Supplements": "Suppléments",
	"TemporarilyUnavailable": "Temporairement indisponible",
	"TheUsernameAndOrPasswordIsIncorrect": "Nom d'utilisateur et/ou mot de passe incorrect(s)",
	"UnknownError": "Une erreur s’est produite",
	"UnknownUser": "Nom d'utilisateur ou mot de passe incorrect",
	"Username": "E-mail",
	"ValidationFailed": "Le service d'authentification est actuellement indisponible.",
	"YourSessionHasExpired": "Votre session a expiré",
	"downloadPDFerror": "Vous avez atteint la limite de téléchargement pour cette édition",
	"ForgotPassword": "Mot de passe oublié",
	"Cancel": "Annuler",
	"moment": "fr",
	"Extra": "Extra",
	"ChooseRegion": "Choisissez une région",
	"downloadingNewsPaper": "Chargement du journal, merci de patienter. ",
	"CookieConfirmButton": "OK",
	"CookieLinkText": "Plus d'information",
	"CookieInformText": "Ce site utilise des cookies. En continuant d'utiliser ce site Web, vous consentez à utiliser les cookies. ",
	"Proceed": "Suivant",
	"home": "Accueil",
	"recently": "Récemment publié",
	"supplements": "Suppléments",
	"extras": "Extras",
	"inforAndExtras": "Infos en continu",
	"regions": "Régions",
	"settings": "Paramètres",
	"region": "Région",
	"login": "Se connecter",
	"logout": "Se déconnecter",
	"help": "Aide",
	"about": "A propos",
	"disclaimer": "Conditions",
	"account": "Abonnement",
	"accountLoggedIn": "Connecté",
	"accountLoggedInInfo": "Vous êtes connecté avec un abonnement valide.",
	"accountLoggedWithInfo": "Vous êtes connecté avec",
	"accountLoggedOut": "Pas connecté",
	"version": "Version",
	"platformversion": "Version de la plateforme",
	"uuid": "UUID",
	"editor": "Editeur",
	"developer": "Développeur",
	"downloading": "Chargement...",
	"journal": "Journal",
	"alsoRead": "Lire aussi",
	"alsoWatch": "Voir aussi",
	"alsoSee": "Voir aussi",
	"authorising": "Autorisation...",
	"notSupported": "Ce site n'est accessible qu'aux navigateurs récents. Veuillez mettre à jour votre navigateur, ou télécharger Chrome.",
	"printImage": "Image",
	"printText": "Texte",
	"print": "Imprimer",
	"jumpBack": "Retour",
	"noInternetNoVideo": "Vous devez être connecté pour visionner cette vidéo.",
	"download": "Télécharger",
	"fullPdfDownload": "Toutes les pages",
	"pagePdfDownload": "Page actuelle",
	"pdfDownloadTooltip": "Télécharger",
	"logoTooltip": "Retour au kiosque",
	"readerLogoTooltip": "Retour au kiosque",
	"landscapeToggle": "Mode paysage",
	"singlePage": "Affichage en page seule",
	"singlePageShort": "Page Seule",
	"doublePage": "Affichage en double page",
	"doublePageShort": "Double page",
	"passwordForgottenLoadingText": "Veuillez patienter durant le chargement de la page",
	"landscapeToggleEExplanation": "Lors de la lecture en mode paysage, vous pouvez choisir d’afficher une seule page ou en double page.",
	"PleaseFillInAValidEmail": "Veuillez remplir une adresse e-mail valide.",
	"LeftPage": "Page gauche",
	"RightPage": "Page droite",
	"Sorry": "Désolé",
	"close": "Fermer",
	"printLeftPage": "Page gauche",
	"printRightPage": "Page droite",
	"printSinglePage": "Page actuelle",
	"cropPrint": "Imprimer",
	"cropPrintInstruction": "Pour imprimer la page en entier, cliquez sur \"Imprimer\".<br>Pour imprimer une partie de la page ou un article spécifique, ajustez le cadre bleu avec votre souris autour de la zone à imprimer.",
	"cropPrintTitle": "Imprimer",
	"openCMPSetting": "Modifier mes choix traceurs",
	"dataPolicy": "Données personnelles",
	"privacyPolicy": "Gestion des cookies",
	"singlePageMode": "Format une page",
	"doublePageMode": "Format double page",
	"readingModeToggle": "Mode de Lecture",
	"E1": "Les systèmes ne sont pas disponibles, veuillez réessayer plus tard.",
	"E2": "",
	"E3": "Le service d'authentification est actuellement indisponible.",
	"E4": "Les systèmes ne sont pas disponibles, veuillez réessayer plus tard.",
	"E5": "Vous n'avez pas d'abonnement actif.",
	"E6": "Nom d'utilisateur et/ou mot de passe incorrect(s)",
	"E7": "Nom d'utilisateur et/ou mot de passe incorrect(s)",
	"E8": "Le journal ne peut être ouvert pour le moment. Merci de ré-essayer plus tard",
	"E9": "Les systèmes ne sont pas disponibles, veuillez réessayer plus tard.",
	"E11": "Vous avez atteint la limite du nombre d'appareils distincts autorisés à consulter cette publication",
	"E13": "Les systèmes ne sont pas disponibles, veuillez réessayer plus tard.",
	"E15": "Les systèmes ne sont pas disponibles, veuillez réessayer plus tard.",
	"E16": "Une erreur s’est produite",
	"E17": "Le service d'authentification est actuellement indisponible.",
	"E20": "Le service d'authentification est actuellement indisponible.",
	"E21": "Le service d'authentification est actuellement indisponible.",
	"E24": "Votre abonnement ne vous permet pas d'accéder à ce journal. Veuillez contacter notre service clientèle.",
	"E25": "Vous avez atteint le nombre total d'accès simultanés pour cette abonnement. Veuillez réessayer plus tard.",
	"E26": "Vos informations d'identification ne peuvent pas être vérifiées. Veuillez réessayer ou contacter notre service client."
};


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/fr_FR.json
// module id = 416
// module chunks = 0 1